var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center"}},[_c('h1',{style:({
				fontSize: _vm.fontSize,
				marginTop: '20px',
				marginBottom: _vm.marginBottom
			})},[_vm._v(" "+_vm._s(_vm.titleName)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }